import {
  Box,
  Stack,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import box from '../../assets/img/box.png';
import { useChrLdFlag } from '@chr/common-launchdarkly';

export interface NotFoundProps {
  onCheckFAQ: (event: object) => void;
}

export const NotFound = ({ onCheckFAQ }: NotFoundProps) => {
  const { breakpoints } = useTheme();
  const isMobileScreen = useMediaQuery(breakpoints.down('md'));
  const translate = useTranslation();
  const shouldShowEnhancedTrackingText = useChrLdFlag('enhanced-externaltracking-search', false);
  let notFoundText = 'Please verify you are providing the correct order or shipment Tracking Number and try again. If you need assistance, our FAQ section may have answers for you.';

  if (shouldShowEnhancedTrackingText) {
    notFoundText = 'Please ensure that your Tracking or Reference Number is correct, or try another one. For additional help, visit our FAQ section for guidance.';
  }

  return (
    <Box
      data-testid="not-found"
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'white',
        padding: '56px 24px 60px',
        ...(isMobileScreen ? {} : { height: 'calc(100% - 440px)' }),
      }}
    >
      <Box
        sx={{
          marginBottom: '32px',
        }}
      >
        <img
          src={box}
          alt="Empty State Illustration"
          width="100px"
          height="100px"
        />
      </Box>
      <Stack
        width={isMobileScreen ? '100%' : '650px'}
        alignItems="center"
        spacing={0.5}
      >
        <Typography variant="h3" sx={{ paddingBottom: '8px' }}>
          {translate('Tracking details not found.')}
        </Typography>
        <Typography variant="body1">
          {translate(
            notFoundText
          )}
        </Typography>
        <Button
          id="check-faq-btn"
          onClick={onCheckFAQ}
          sx={{ marginTop: '24px', padding: '6px 14px' }}
          variant="text"
        >
          {translate('Check FAQ')}
        </Button>
      </Stack>
    </Box>
  );
};
